import { gql } from '@apollo/client'

export const TEMPLATE_SUBMISSION_MUTATION = gql`
    mutation putTemplateSubmission($request: TemplateSubmissionRequest) {
        putTemplateSubmission(request: $request)
    }
`

